var _filter, _rect, _line, _line2, _line3, _rect2, _text, _text2, _rect3, _rect4, _rect5, _text3, _text4, _text5, _rect6, _text6, _text7, _text8, _rect7, _text9, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _text0, _text1, _text10, _text11, _text12, _text13, _rect12, _text14, _circle, _circle2, _circle3, _circle4, _circle5, _text15, _text16, _circle6, _text17, _circle7, _text18, _circle8, _text19, _circle9, _text20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpensetracker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f172a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e293b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar1",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a78bfa"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#34d399"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodColor: "#000",
    floodOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 600,
    y2: 100,
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 600,
    y2: 200,
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 600,
    y2: 300,
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 250,
    height: 90,
    rx: 16,
    fill: "url(#card1)",
    filter: "url(#shadow)",
    opacity: 0.95
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 60,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 12,
    opacity: 0.8
  }, "Monthly Budget")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 88,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: "bold"
  }, "\u20B1 15,000")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 100,
    width: 200,
    height: 6,
    rx: 3,
    fill: "rgba(255,255,255,0.2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 100,
    width: 130,
    height: 6,
    rx: 3,
    fill: "white",
    opacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 30,
    width: 120,
    height: 90,
    rx: 14,
    fill: "#1e293b",
    filter: "url(#shadow)",
    stroke: "#6366f133",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 318,
    y: 60,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 11
  }, "Spent")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 318,
    y: 85,
    fill: "#6366f1",
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: "bold"
  }, "\u20B18,650")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 318,
    y: 108,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 11
  }, "\u25BC 12%")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 30,
    width: 130,
    height: 90,
    rx: 14,
    fill: "#1e293b",
    filter: "url(#shadow)",
    stroke: "#10b98133",
    strokeWidth: 1
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 456,
    y: 60,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 11
  }, "Remaining")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 456,
    y: 85,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: "bold"
  }, "\u20B16,350")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 456,
    y: 108,
    fill: "#6366f1",
    fontFamily: "Arial",
    fontSize: 11
  }, "42% left")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 145,
    width: 250,
    height: 220,
    rx: 16,
    fill: "#1e293b",
    filter: "url(#shadow)",
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 172,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 13,
    fontWeight: "bold"
  }, "6-Month Trend")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 275,
    width: 22,
    height: 70,
    rx: 5,
    fill: "url(#bar1)",
    opacity: 0.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 255,
    width: 22,
    height: 90,
    rx: 5,
    fill: "url(#bar1)",
    opacity: 0.8
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 240,
    width: 22,
    height: 105,
    rx: 5,
    fill: "url(#bar1)",
    opacity: 0.9
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 260,
    width: 22,
    height: 85,
    rx: 5,
    fill: "url(#bar1)",
    opacity: 0.85
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 230,
    width: 22,
    height: 115,
    rx: 5,
    fill: "url(#bar1)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 250,
    width: 22,
    height: 95,
    rx: 5,
    fill: "url(#bar2)"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 360,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9
  }, "Oct")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 360,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9
  }, "Nov")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 360,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9
  }, "Dec")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 163,
    y: 360,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9
  }, "Jan")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 360,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9
  }, "Feb")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 233,
    y: 360,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 9
  }, "Mar")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 145,
    width: 270,
    height: 220,
    rx: 16,
    fill: "#1e293b",
    filter: "url(#shadow)",
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 172,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 13,
    fontWeight: "bold"
  }, "Categories")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 260,
    r: 55,
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 22,
    strokeDasharray: "104 243",
    strokeDashoffset: 0,
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 260,
    r: 55,
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 22,
    strokeDasharray: "76 243",
    strokeDashoffset: -104,
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 260,
    r: 55,
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 22,
    strokeDasharray: "50 243",
    strokeDashoffset: -180,
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 260,
    r: 55,
    fill: "none",
    stroke: "#ec4899",
    strokeWidth: 22,
    strokeDasharray: "13 243",
    strokeDashoffset: -230,
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 260,
    r: 44,
    fill: "#1e293b"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 255,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "\u20B18,650")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 272,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 9,
    textAnchor: "middle"
  }, "total spent")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 215,
    r: 5,
    fill: "#6366f1"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 219,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 10
  }, "Food 43%")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 235,
    r: 5,
    fill: "#10b981"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 239,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 10
  }, "Transport 31%")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 255,
    r: 5,
    fill: "#f59e0b"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 259,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 10
  }, "Shopping 21%")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 275,
    r: 5,
    fill: "#ec4899"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 279,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 10
  }, "Other 5%")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpensetracker);
export default __webpack_public_path__ + "static/media/expensetracker.d074467c22a22aa09343d10b2cfde6db.svg";
export { ForwardRef as ReactComponent };